import { FlexComponent } from "typings/flexFramework/FlexComponent";
import { BlossomComponentsFactory } from "components/flexFramework/domain/BlossomComponentsFactory";
import { BlossomComponent } from "components/flexFramework/domain/BlossomComponent";
import { flexComponentMap } from "components/flexFramework/FlexComponents/flexComponentMap";

/**
 * Describes a Blossom Component deriving from Flex Composition data source.
 */
export class BlossomComponentFromComposition extends BlossomComponent {
  public readonly flexComponent: FlexComponent;
  public readonly isInsideTabGroup: boolean;

  public constructor(flexComponent: FlexComponent, isInsideTabGroup: boolean = false) {
    super(flexComponent, flexComponentMap);
    this.flexComponent = flexComponent;
    this.type = flexComponent.type;
    this.isInsideTabGroup = isInsideTabGroup;
  }

  public shouldRender = () =>
    this.flexComponent.model && !this.flexComponent.model.error && !this.flexComponent.model.empty;

  // Since regions don't have consistent names, we need to handle them properly.
  // Otherwise, just give the component name
  public getName = () =>
    this.flexComponent.type === "Region" ? "region" : this.flexComponent.name;
  public getId = () => this.flexComponent.id;
  public getView = () => this.flexComponent.model && this.flexComponent.model.view;
  public getBlossomComponents = () => {
    return [
      ...BlossomComponentsFactory.get({ flexComponents: this.flexComponent.modules }),
      ...BlossomComponentsFactory.get({ flexComponents: this.flexComponent.groups }),
      ...BlossomComponentsFactory.get({ flexComponents: this.flexComponent.children })
    ];
  };

  public getProps = () => {
    return {
      flexComponent: this.flexComponent,
      isInsideTabGroup: this.isInsideTabGroup
    };
  };

  /**
   * Returns the model as whatever the typing it should be.
   */
  public getModel = <T>() => {
    return this.flexComponent.model as T;
  };
}
